import { Stack, Typography } from '@mui/material';
import { UserAvatar } from '@pinnacleautomotive/clarity-components';

export function NameAvatarCell({ user }) {
  return (
    <Stack direction="row" gap={1} alignItems="center">
      <UserAvatar
        photo={user.photo}
        firstName={user.firstName}
        lastName={user.lastName}
      />
      <Stack>
        <Typography variant="body2">
          {[user.firstName, user.lastName].filter(x => x).join(' ')}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {user.title}
        </Typography>
      </Stack>
    </Stack>
  );
}
